import "./Testimonials.module.css";
import Header from "@/reusable_sections/Header";
import ReviewsHero from "./sections/ReviewsHero";
import Review from "./sections/Review";
import Credibility from "./sections/Credibility";
import CustomerReviews from "./sections/CustomerReviews";
import Footer from "@/reusable_sections/Footer";
import FinalCta from "./sections/FinalCta";
import TrustStrip from "./sections/TrustStrip";
export default function TestimonialsPage() {
  return <div>
      <Header />
      <ReviewsHero />
      <FinalCta />
      <CustomerReviews />
      <Review />
      <Credibility />
      <TrustStrip />
      <Footer />
    </div>;
}